import { shallowRef } from 'vue'

export const COHORT_SELECTION_KEY = 'wuji-cohort:selected-cohort'

const normalizeSelection = cohort => cohort && typeof cohort === 'object' && !Array.isArray(cohort)
  ? { ...cohort, realtime_monitoring_enabled: cohort.realtime_monitoring_enabled === true }
  : null

export function selectedCohort() {
  try {
    return normalizeSelection(JSON.parse(localStorage.getItem(COHORT_SELECTION_KEY) || 'null'))
  } catch {
    return null
  }
}

export const selectedCohortState = shallowRef(selectedCohort())

export function saveSelectedCohort(cohort) {
  const selection = normalizeSelection(cohort)
  if (selection) localStorage.setItem(COHORT_SELECTION_KEY, JSON.stringify(selection))
  else localStorage.removeItem(COHORT_SELECTION_KEY)
  selectedCohortState.value = selection
  return selection
}

export function reconcileSelectedCohort(nodes) {
  const current = selectedCohortState.value || selectedCohort()
  if (!current?.id) return saveSelectedCohort(null)
  const discovered = Array.isArray(nodes) ? nodes.find(node => node?.id === current.id) : null
  if (!discovered || discovered.status === 'preparing') return saveSelectedCohort(null)
  const next = { ...current, ...discovered }
  if (current.site != null) next.site = current.site
  return saveSelectedCohort(next)
}
